import React from "react";
import { Fade } from "react-awesome-reveal";
import { Link, NavLink } from "react-router-dom";
import Slider from "react-slick";
import { WebLogo } from "utils/Icons";
import QueryChecker from "utils/queryChecker";

const HomeLoginSignUp = () => {
  // slider settings / config
  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
  };

  // Text data for slider
  const textData = [
    {
      title: `Become a Happier & Calmer Mom`,
      desc: `Transform your negative emotions to more positive, loving, and empowering ones.`,
    },
    {
      title: `Increase patience & reduce motherhood guilt`,
      desc: `Our proven Mindpower Sessions™ combine meditation, hypnotherapy & mindfulness.`,
    },
    {
      title: `Raise Happier Kids`,
      desc: `Research shows that happy moms = happy kids. You enjoy your motherhood experience on a whole new level.`,
    },
  ];
  const withQuery = QueryChecker(["promo","email","sId"]);

  return (
    <div className="signup_card text_center text_white home_login_screen text_center">
      {/* logo */}
      <div className="music_web_logo">
        <Fade triggerOnce delay={700} duration={1700}>
          <WebLogo />
        </Fade>
      </div>
      {/*  */}
      <div className="home_login_screen_slider">
        <Fade triggerOnce delay={1100} duration={2200}>
          <Slider {...settings}>
            {textData?.map((item, index) => (
              <div key={index}>
                <div className="home_login_screen_slider_card text_center">
                  <h3>{item.title}</h3>
                  <p>{item?.desc}</p>
                </div>
              </div>
            ))}
          </Slider>
        </Fade>
      </div>
      {/*  */}
      <div className="screen_sticky_footer">
        <Fade triggerOnce delay={1900} duration={230}>
          <NavLink to={"/register" + withQuery} className="cs_btn w_100">
            Get Started
          </NavLink>
        </Fade>
        <Fade triggerOnce delay={2220} duration={2300}>
          <div className="text_center home_login_bottom d_flex align_items_center justify_content_center text_center text_white">
            <Link to={"/login"+ withQuery} className="text_white text_decoration_none">
              Already have an account? Log In
            </Link>
          </div>
        </Fade>
      </div>
    </div>
  );
};

export default HomeLoginSignUp;
